import { LatLng, LeafletMouseEvent } from 'leaflet';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Polygon, PolygonProps } from 'react-leaflet';
import { getOrientationMarkerCoords } from '../../../../helpers/geometry/orientedRectangle.helpers';
import { ISegmentationFeature } from '../../annotations.interface';
import { AnnotationToolType } from '../../submodules/annotationTypes/models/annotationToolType';
import { ISegmentationPolygonProps } from '../SegmentationLayerFeatures';

interface IRotatedRectangleFeatureProps {
  isActive: boolean;
  feature: ISegmentationFeature;
  latlngs: LatLng[];
  opacity: number;
  fillOpacity: number;
  zoomLevel: number;
  className?: string;
  onSegmentationOver: (e: L.LeafletMouseEvent) => void;
  onSegmentationOut: (e: L.LeafletMouseEvent) => void;
  onClick: (e: LeafletMouseEvent) => void;
  onContextMenu: (e: LeafletMouseEvent) => void;
  dashArray?: string | number[] | undefined;
  tooltip?: ReactElement;
}

export const RotatedRectangleFeature = observer((props: IRotatedRectangleFeatureProps): ReactElement => {
  const handleRef = (element: Polygon<ISegmentationPolygonProps & PolygonProps>): void => {
    if (props.isActive && element && 'enableEdit' in element.leafletElement && typeof element.leafletElement.enableEdit === 'function') {
      element.leafletElement.enableEdit();
    }
  };

  return (
    <div
      key={`${props.feature.id}-orientation-marker-container`}
      className={'rotated-rectange'}
    >
      <Polygon<ISegmentationPolygonProps & PolygonProps>
        key={`${props.feature.id}-orientation-marker`}
        storeKey={`${props.feature.id}-orientation-marker`}
        fillOpacity={props.opacity}
        color={props.feature.color}
        type={AnnotationToolType.ROTATEDRECTANGLE}
        positions={getOrientationMarkerCoords(props.latlngs[3], props.latlngs[0], props.latlngs[1], props.zoomLevel)}
        canRotate={false}
        opacity={props.opacity}
        className='orientation-marker'
        onclick={props.onClick}
        onmouseover={props.onSegmentationOver}
        onmouseout={props.onSegmentationOut}
      />
      <Polygon<ISegmentationPolygonProps & PolygonProps>
        ref={handleRef}
        key={props.feature.id}
        storeKey={props.feature.id}
        fillOpacity={props.fillOpacity}
        color={props.feature.color}
        type={AnnotationToolType.ROTATEDRECTANGLE}
        positions={props.latlngs}
        onclick={props.onClick}
        onmouseover={props.onSegmentationOver}
        onmouseout={props.onSegmentationOut}
        oncontextmenu={props.onContextMenu}
        canRotate={true}
        opacity={props.opacity}
        className={props.className}
        dashArray={props.dashArray}
      >
        {props.tooltip}
      </Polygon>
    </div>
  );
});
